module.exports = __webpack_public_path__ + "static/media/document-generator.dff0870a.png";